<template>
  <div>
    <a-row>
      <a-col :span="24">
        <div class="top">
          <span class="a-span">角色名称：</span>
          <a-input
            class="a-input"
            v-model="roleName"
            placeholder="请输入角色名称"
          ></a-input>
          <span class="b-span">角色描述：</span>
          <a-textarea
            v-model="roleDesc"
            class="a-textarea"
            placeholder="请输入角色描述"
            :rows="4"
          />
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <div class="top" style="height: auto;">
          <a-tree
            class="tree"
            v-model="checkedKeys"
            checkable
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            :selected-keys="selectedKeys"
            :tree-data="ywArr"
            @expand="onExpand"
            @select="onSelect"
            :replaceFields="{ children: 'children' }"
          />
        </div>
      </a-col>
    </a-row>
    <div class="s-button">
      <a-button @click="save">保存</a-button>
      <a-button @click="goBack">返回</a-button>
    </div>
  </div>
</template>
<script>
import { partManagementList, partManagementAdd } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const ywArr = [];
const xmArr = [];
export default {
  inject: ["reload"],
  data() {
    return {
      expandedKeys: ["0-0-0", "0-0-1"],
      autoExpandParent: true,
      checkedKeys: ["0-0-0"],
      selectedKeys: [],
      xmArr,
      ywArr,
      menuIdList: [],
      roleName: "",
      roleDesc: "",
    };
  },
  watch: {
    checkedKeys(val) {
      console.log("onCheck", val);
    },
  },
  created() {
    this.getPartManagementList();
  },
  methods: {
    onExpand(expandedKeys) {
      console.log("onExpand", expandedKeys);
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      console.log("onCheck", checkedKeys);
      this.checkedKeys = checkedKeys;
      this.menuIdList = checkedKeys;
    },
    onSelect(selectedKeys, info) {
      console.log("onSelect", info);
      this.selectedKeys = selectedKeys;
    },
    getPartManagementList() {
      partManagementList().then((res) => {
        res.data.map((item) => {
          this.ywArr.push({
            title: item.name,
            key: item.objId,
            children: this.loop(item.children),
          });
        });
      });
    },
    loop(item) {
      if (item !== null) {
        console.log(item, "item ==> 不为null");
        let arr = [];
        item.forEach((item) => {
          arr.push({
            title: item.name,
            key: item.objId,
          });
        });
        return arr;
      }
    },
    save() {
      let obj = {
        isShop: 1,
        roleName: this.roleName,
        roleDesc: this.roleDesc,
        menuIdList: this.checkedKeys,
      };
      if (this.roleName.trim() !== "") {
        partManagementAdd(obj).then((res) => {
          message.success(res.info);
          this.$router.push("/home/partManagement/partManagementHome");
          location.reload();
        });
      } else {
        message.warning("角色名称不可为空");
      }
    },
    goBack() {
      this.$router.push("/home/partManagement/partManagementHome");
      location.reload();
    },
  },
};
</script>

<style scoped>
.s-button {
  margin-left: 20px;
}
.tree {
  position: relative;
  left: 160px;
}
.a-span {
  position: relative;
  left: 80px;
  top: 25px;
}
.b-span {
  position: relative;
  top: 75px;
  left: 80px;
}
.a-input {
  position: relative;
  left: 160px;
  display: block;
  width: 350px;
}
.a-textarea {
  position: relative;
  left: 160px;
  top: 50px;
  display: block;
  width: 450px;
}
.top {
  margin: 15px;
  height: 400px;
  background-color: rgb(255, 255, 255);
}
</style>


// WEBPACK FOOTER //
// src/views/right/partManagement/addpartManagement/addpartManagement.vue